<template>
  <div>
    <el-row>
      <el-col :span="16" class="cs-auen-step3-left">
        <div>
          <span class="cs-title">价格详情</span>
        </div>
        <courseList ref="courseList" :isReadonly="true" :hasPrice="true" :dataIn="courseListData" />

      </el-col>
      <el-col :span="8" class="cs-auen-step3-right">
        <el-row>
          <el-col>
            <span class="cs-title">付款方式</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <payment :readonly="isReadonly" :data="paymentDataIn" @success="onPaymentSuccess" />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-auen-step3-left,
.cs-auen-step3-right {
  margin-top: 1rem;
}
.cs-auen-step3-left {
  border-right: 1px solid #ced3d9;
  padding-right: 20px;
}
.cs-auen-step3-right {
  padding-left: 20px;

  button {
    margin-top: 10px;
  }
}
</style>

<script>
import courseList from "./courseList";

export default {
  components: {
    courseList,
    payment: () => import("@/components/payApi/payment"),
  },
  props: {
    isReadonly: Boolean,
    dataIn: {
      studentId: Number,
      workflowId: Number,
      studentMemberInfo: Object,
      courseList: Object,
      model: {
        paymentType: Number,
      },
    },
  },
  data() {
    return {
      isLoading: false,
      paymentDataIn: {
        workflowId: 0,
        paymentAmount: 0,
        paymentType: null,
        product: null,
        description: null,
      },
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.model = this.dataIn.model;
      this.courseListData = {
        studentMemberInfo: this.dataIn.studentMemberInfo,
        courseList: this.dataIn.courseList,
      };

      this.$nextTick(() => {
        let accountAmount = this.dataIn.courseList.calcAccountAmount();
        let paymentAmount = accountAmount;
        let strCourseNames = this.dataIn.courseList.data.reduce(
          (prev, item) => `${prev}${item.CourseName},`,
          String.empty
        );
        strCourseNames = strCourseNames.rTrim(",");
        let product = `课程报名：${strCourseNames}`;
        let description = `课程报名：${strCourseNames}`;
        this.paymentDataIn = {
          workflowId: this.dataIn.workflowId,
          paymentAmount,
          paymentType: this.dataIn.model.paymentType,
          product,
          description,
        };
      });
    },
    onPaymentSuccess(dataOut) {
      //TODO: 完成流程
      this.$emit("paymentSuccess", dataOut);
      console.log("onPaymentSuccess:", dataOut);
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/autonomousEnrolment/workflow/step3.vue